if (!customElements.get("product-addons")) {
  class ProductAddons extends PopupBase {
    constructor() {
      super();
      this.productPopupDiv = this.querySelector(".product-addons__content");
      this.init();
    }
    init() {
      if (this.productPopupDiv) {
        this.addEventListener("click", this.onClick.bind(this));
      }
    }
    onClick(e) {
      const a = e.target.closest("a[href]");
      if (a && a.getAttribute("href") === "#") {
        e.preventDefault();
      }
      const html = this.productPopupDiv;
      if (!html) return;
      html.classList.remove("hidden");
      this.initPopup(
        html,
        `<h3 class="title-popup h5 my-0 px-20 px-md-30 py-20 border-bottom">${this.dataset?.textHeader}</h3>`
      );
    }
  }
  customElements.define("product-addons", ProductAddons);
}

const normalizeWhatsAppTarget = (target) => {
  if (!target) return "";
  const trimmedTarget = target.trim();
  if (!trimmedTarget) return "";
  if (/^https?:\/\//i.test(trimmedTarget)) {
    return trimmedTarget;
  }
  if (/^wa\.me\//i.test(trimmedTarget) || /^api\.whatsapp\.com\//i.test(trimmedTarget)) {
    return `https://${trimmedTarget}`;
  }
  const numberOnly = trimmedTarget.replace(/[^\d]/g, "");
  if (!numberOnly) return "";
  return `https://wa.me/${numberOnly}`;
};

document.addEventListener("click", (event) => {
  const whatsappButton = event.target.closest(".ask-question-whatsapp-submit");
  if (!whatsappButton) return;

  event.preventDefault();

  const form = whatsappButton.closest("form");
  if (!form) return;

  const target = normalizeWhatsAppTarget(whatsappButton.dataset.whatsappTarget || "");
  if (!target) return;

  const getInputValue = (selector) => {
    const el = form.querySelector(selector);
    if (!el) return "";
    return (el.value || "").trim();
  };

  const pageUrlInput = form.querySelector('input[name="contact[Page URL]"]');
  const name = getInputValue('input[id^="Ask-name"]');
  const phone = getInputValue('input[id^="Ask-phone"]');
  const email = getInputValue('input[id^="Ask-email"]');
  const enquiryType = getInputValue('select[id^="Ask-enquiry-type"]');
  const message = getInputValue('textarea[id^="AskMessage"]');
  const pageUrl = pageUrlInput ? (pageUrlInput.value || "").trim() : window.location.href;

  const lines = [];
  const pushLine = (label, value) => {
    if (value) lines.push(`${label}: ${value}`);
  };

  lines.push(whatsappButton.dataset.whatsappTitle || "Enquiry");
  lines.push("");
  pushLine(whatsappButton.dataset.whatsappLabelName || "Name", name);
  pushLine(whatsappButton.dataset.whatsappLabelPhone || "Phone", phone);
  pushLine(whatsappButton.dataset.whatsappLabelEmail || "Email", email);
  pushLine(
    whatsappButton.dataset.whatsappLabelEnquiryType || "Enquiry Type",
    enquiryType
  );
  pushLine(whatsappButton.dataset.whatsappLabelMessage || "Message", message);
  pushLine(whatsappButton.dataset.whatsappLabelPageUrl || "Page URL", pageUrl);

  const text = encodeURIComponent(lines.join("\n"));
  const separator = target.includes("?") ? "&" : "?";
  window.open(`${target}${separator}text=${text}`, "_blank", "noopener");
});
